<template src="./gestioneUtente.html"></template>

<script>
import DialogCliente from "@/components/dialog/DettaglioCliente.vue";
import { get_listaClienti, delete_cliente, get_certificazioni, get_clientiExcel } from "@/api/api.dati.js";

var XLSX = require("xlsx");

import mixinUtente from "@/utils/dati/mixinUtente";

export default {
    components: { DialogCliente },

    mixins: [mixinUtente],

    data: () => ({
        headerProps: {
            sortByText: "Ordina per",
        },
        page: 1,
        pageCount: 0,
        search: "",
        loadingTabella: false,
        clienti: [],
        dialogCliente: false,

        expanded: [],
        gruppo: ["Tutti", "G", "S"],
        gruppoSel: -1,
        certificazione: [],
        certificazioneSel: -1,
        editedItem: {},
        isEdited: false,

        headersDati: [],

        selectedRow: null,

        dialogDataCoc: false,
        dialogDataFPC: false,
        dataCocIT: new Date().toISOString().substr(0, 10),
        dataCoc: new Date().toISOString().substr(0, 10),
        dataFPCIT: new Date().toISOString().substr(0, 10),
        dataFPC: new Date().toISOString().substr(0, 10),
    }),

    methods: {
        async CaricaDati() {
            this.loadingTabella = true;

            this.clienti = [];
            let par = {
                Cliente: true,
                Gruppo: this.gruppoSel,
                Certificazione: "",
                DataCoc: "",
                DataFPC: "",
            }
            //controllo per filtro date Audit
            if (this.dataCocIT != "" && this.dataCocIT != null) par.DataCoc = this.dataCoc;
            else par.DataCoc = "";
            if (this.dataFPCIT != "" && this.dataFPCIT != null) par.DataFPC = this.dataFPC;
            else par.DataFPC = "";
            //controllo per filtro Certificazione
            if (this.certificazioneSel.id == 2) par.Certificazione = "FSCS";
            else if (this.certificazioneSel.id == 3) par.Certificazione = "FSCG";
            else par.Certificazione = this.certificazioneSel.certificazione;

            let res = await get_listaClienti(par);
            this.clienti = res.data;

            this.loadingTabella = false;
        },

        async refresh() {
            //reset filtri
            this.resetFiltri();

            await this.CaricaDati();
        },

        resetFiltri() {
            this.gruppoSel = this.gruppo[0];
            this.certificazioneSel = this.certificazione[0];

            this.dialogDataCoc = false;
            this.dialogDataFPC = false;
            //this.dataCoc = new Date().toISOString().substr(0, 10);
            //this.dataFPC = new Date().toISOString().substr(0, 10);
            this.dataCocIT = "";
            this.dataFPCIT = "";
        },

        selectRow(i) {
            this.selectedRow = i;
        },

        async deleteItem(item) {
            let numero = item.userId - 1;
            let confirm = await this.$confirm.open("Elimina cliente n°" + numero, "Vuoi eliminare il cliente: <b>" + item.username + "</b>?");
            if (!confirm) return;

            this.loadingTabella = true;
            item.certificazione = "";
            let res = await delete_cliente(item);
            if (res.data == "OK") {
                this.CaricaDati();
                if (item.id != 0) this.CaricaDati();
                this.$toast.info("Cliente eliminato con successo!");
            } else this.$toast.alert("Impossibile eliminare il cliente!");

            this.loadingTabella = false;
        },

        editItem(item) {
            item.expanded = false;
            this.editedItem = item;
            this.operazione = "Modifica elemento";
            this.isEdited = true;
            this.dialogCliente = true;
        },

        aggiungi() {
            this.isEdited = false;
            this.dialogCliente = true;
        },

        chiudiCliente(value) {
            this.editedItem = null;
            this.dialogCliente = false;
            if (!value) this.refresh();
        },

        async GetCertificazioni() {
            this.loadingTabella = true;
            this.certificazione = [];

            let res = await get_certificazioni();
            this.certificazione = res.data;

            this.loadingTabella = false;
        },

        async esportaExcel() {
            this.$wait.open();

            let res = await get_clientiExcel();

            let sheetData = res.data;
            let nomeFile = "";
            let workbook = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(sheetData);

            ws["!cols"] = this.getDimensioneColonne();
            nomeFile = "ReportClientiGruppo";

            XLSX.utils.book_append_sheet(workbook, ws, nomeFile);

            let wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            //salvo il file (il browser lo scarica in automatico)
            XLSX.writeFile(workbook, nomeFile + ".xlsx", wopts);
            this.$wait.close();
        },
    },

    async mounted() {
        //data Audit Coc
        let data = new Date(this.dataCocIT);
        data.setDate(data.getDate()); //formato system
        data = this.$i2kFunctions.formatDate_IT(data); //dd/MM//YYYY;
        this.dataCocIT = "";
        //data audit FPC
        let data1 = new Date(this.dataFPCIT);
        data1.setDate(data1.getDate()); //formato system
        data1 = this.$i2kFunctions.formatDate_IT(data1); //dd/MM//YYYY;
        this.dataFPCIT = "";

        this.gruppoSel = this.gruppo[0];
        await this.GetCertificazioni();
        this.certificazioneSel = this.certificazione[0];
        await this.CaricaDati();
    },

    watch: {
        dataCoc() {
            let data = new Date(this.dataCoc);
            data.setDate(data.getDate()); //formato system
            data = this.$i2kFunctions.formatDate_IT(data); //dd/MM//YYYY;
            this.dataCocIT = data;
        },
        dataFPC() {
            let data = new Date(this.dataFPC);
            data.setDate(data.getDate()); //formato system
            data = this.$i2kFunctions.formatDate_IT(data); //dd/MM//YYYY;
            this.dataFPCIT = data;
        },
        async dataCocIT(newVal) {
            if (newVal) {
                this.dataFPCIT = "";
                await this.CaricaDati();
            }
        },
        async dataFPCIT(newVal) {
            if (newVal) {
                this.dataCocIT = "";
                await this.CaricaDati();
            }
        },
    },

    created() {
        if (!["admin", "auditor"].includes(this.role))
            this.$router.push({ path: "/" });
        this.headersDati = this.getHeadersTabella();
    },

    computed: {
        GetLoading() {
            return this.$store.getters["app/getLoading"];
        },
        role() {
            return this.$store.getters['user/getRole'];
        },
    },
};
</script>